export type SearchRequestBody = {
  textQuery: string;
  maxResult: number;
  objectTypes: SearchObjectTypes[];
  preHighlightTag: string;
  postHighlightTag: string;
};

export enum SearchObjectTypes {
  NOTE = "NOTE",
  PERSON = "PERSON",
}

export type SearchResponse = {
  results: SearchResponseResultItem[];
};

export type SearchResponseResultItem = {
  total: number;
  objectType: SearchObjectTypes;
  items: SearchResponseItem[];
};

export type SearchResponseItem = {
  score: number;
  fields: SearchResponseItemField[];
  firstName: string | null;
  lastName: string | null;
  personId: string | null;
  noteId: string | null;
};

export type SearchResponseItemField = {
  name: string;
  value: string;
};
